export default __webpack_public_path__ + "static/media/47t.05436125.jpg";